import { useInView } from "react-intersection-observer";
import { motion } from "framer-motion";
import { useState } from "react";
import { WorksGallery } from "./WorksGallery";
import { useImagePlacement } from "../../hooks/useImagePlacement";
import { useWorksIcons } from "../../hooks/useWorksIcons";

export function Portfolio() {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const [selectedIcon, setSelectedIcon] = useState<number | null>(null);
  const {
    imageUrls,
    isLoading: isImageLoading,
    error: imageError,
  } = useImagePlacement(6, {
    width: 240,
    height: 100,
    quality: 80,
  });
  const {
    icons,
    isLoading: isIconsLoading,
    error: iconsError,
  } = useWorksIcons();

  return (
    <section id="portfolio" className="py-4">
      <div className="container mx-auto px-4">
        <motion.div
          ref={ref}
          initial={{ opacity: 0, y: 20 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
          className="flex flex-col items-center"
        >
          {isImageLoading ? (
            <div className="text-center">読み込み中...</div>
          ) : imageError ? (
            <div className="text-red-600 text-center">{imageError}</div>
          ) : (
            <div className="text-center mb-2">
              {imageUrls[0] ? (
                <img
                  src={imageUrls[0]}
                  alt="Portfolio"
                  className="mx-auto object-contain"
                />
              ) : (
                <h2 className="text-4xl font-bold">Portfolio</h2>
              )}
            </div>
          )}

          <div className="flex flex-wrap gap-2 justify-center">
            {isIconsLoading ? (
              <div>アイコン読み込み中...</div>
            ) : iconsError ? (
              <div className="text-red-600">
                アイコンの読み込みに失敗しました
              </div>
            ) : (
              icons.map((icon) => (
                <motion.button
                  key={icon.icon}
                  className="flex items-center justify-center cursor-pointer -my-4"
                  whileHover={{ scale: 1.1 }}
                  onClick={() => setSelectedIcon(icon.id)}
                >
                  <img
                    src={icon.iconUrl}
                    alt={icon.icon}
                    className="w-24 h-24 sm:w-28 sm:h-28 lg:w-36 lg:h-36 object-contain"
                  />
                </motion.button>
              ))
            )}
          </div>

          {icons.map((icon) => (
            <WorksGallery
              key={icon.icon}
              worksId={icon.id}
              isVisible={selectedIcon === icon.id}
            />
          ))}
        </motion.div>
      </div>
    </section>
  );
}
